/**
 * Created by Ko-Hsin on 16/05/2018.
 */

import {Component, Input} from '@angular/core';

@Component({
    selector: 'button-seat',
    template: `
        <div class="seat">
            <div class="s"><div class="left"></div></div><div class="bar"></div><div class="s"><div class="right" [ngClass]="config"></div></div>
        </div>
    `,
    styles: [`
        .seat { position: relative; z-index:2; }
        .s { width:25px; height:25px; background:#fff; display: inline-block; }
        .bar { height:10px; width:calc(100% - 60px); background:#fff; display: inline-block; }
        .s .right { border-radius:0 0 0 25px; background:#333; width:100%; height:100%; }
        .s .right.sr { background: #fff; }
        .s .left { border-radius:0 0 25px 0; background:#333; width:100%; height:100%; }

    `]
})
export class SeatComponent {
    @Input() config: any;
}


// WEBPACK FOOTER //
// ./src/app/pages/checkit-dashboard/components/seat.ts